import React from "react";
import type { ChatMessage } from "./types";
import { formatTime } from "./helpers";
import AgentAvatar from "./AgentAvatar";
import MarkdownRenderer from "./MarkdownRenderer";
import MessageActions from "./MessageActions";

interface AssistantMessageProps {
  message: ChatMessage;
  isFirstInGroup: boolean;
  onCopy?: (content: string) => void;
  onRegenerate?: (messageId: string) => void;
  onFeedback?: (messageId: string, feedback: "positive" | "negative") => void;
  currentFeedback?: "positive" | "negative" | null;
}

export default function AssistantMessage({
  message,
  isFirstInGroup,
  onCopy,
  onRegenerate,
  onFeedback,
  currentFeedback,
}: AssistantMessageProps) {
  const isNew = message.isNew && Date.now() - message.timestamp < 500;

  return (
    <div className={`flex gap-3 group ${isNew ? "message-enter" : ""}`}>
      {isFirstInGroup ? <AgentAvatar className="mt-1" /> : <div className="w-7 shrink-0" />}
      <div className="flex-1 min-w-0">
        {isFirstInGroup && (
          <div className="flex items-center gap-2 mb-1">
            <span className="text-[10px]" style={{ color: "var(--c-text-faint)" }}>
              {formatTime(message.timestamp)}
            </span>
          </div>
        )}
        <div className="text-sm break-words" style={{ color: "var(--c-text)" }}>
          <MarkdownRenderer content={message.content} />
        </div>
        <MessageActions
          role="assistant"
          content={message.content}
          messageId={message.id}
          onCopy={onCopy}
          onRegenerate={onRegenerate}
          onFeedback={onFeedback}
          currentFeedback={currentFeedback}
          align="left"
        />
      </div>
    </div>
  );
}
